import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import styles from "./index.module.scss";
import Footer from "./Footer";

function Layout() {
  return (
    <div className={`${styles.page}`}>
      <Sidebar />
      <div className={`row p-0 g-0`} style={{ flex: "auto", overflow: "auto" }}>
        <div className={`${styles.headerContainer}`}>
          <Header />
        </div>
        <div className={`col-12 ${styles.pageBody}`}>
          <Outlet />
        </div>
        <Footer />
      </div>
     
    </div>
  );
}

export default Layout;
